<template>
  <div>
    <div class="wrapper mr-2" v-b-tooltip.hover.bottomleft title="Localize uma proposta">
      <div class="input-group">
        <b-form-input
          placeholder="Busque por CPF, nome ou agência"
          class="search"
          size="sm"
          type="search"
          v-model="searchData"
          @input="updateSearch"
        ></b-form-input>
        <span class="bar"></span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";

export default {
  name: "GlobalSearch",
  props: {
    tabIndex: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      searchData: ""
    };
  },
  watch: {
    tabIndex(newVal) {
      this.searchData = ''
    }
  },
  methods: {
    ...mapActions(["getProposals","globalSearchFieldAction"]),
    async updateSearch(val) {
      this.$emit('tabOnSearch',    {
        index: 10,
        type: 'search'
      })
      await this.globalSearchFieldAction(val)
      await this.getProposals({ tabIndex: 10, scroll: 1 , globalTabType: 'search'});
    }
  },
  computed: {
    ...mapGetters([""])
  }
};
</script>

<style scoped>
/* Start Search Input */
.input-group {
  position: relative;
  font-size: 0.875rem;
}
.input-group .search {
  height: 15px;
  width: 15px;
  /* background-color: #ccc; */
  border: 1px solid #ced4da;
  border-radius: 50%;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.15);
  cursor: pointer;
  color: #fff;
  outline: none;
  padding: 5px;
  position: relative;
  -webkit-transition: all 150ms cubic-bezier(0.2, 0.6, 0.252, 1.2);
  transition: all 150ms cubic-bezier(0.2, 0.6, 0.252, 1.2);
}
.input-group .search ~ .bar {
  height: 3px;
  width: 10px;
  background: #ccc;
  border-radius: 4px;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.15);
  position: absolute;
  display: block;
  opacity: 1;
  right: -6px;
  top: 15px;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  -webkit-transition: opacity 150ms ease;
  transition: opacity 150ms ease;
}
.input-group .search::-webkit-input-placeholder {
  color: #fff;
}
.input-group .search::-moz-placeholder {
  color: #fff;
}
.input-group .search:-ms-input-placeholder {
  color: #fff;
}
.input-group .search::-ms-input-placeholder {
  color: #fff;
}
.input-group .search::placeholder {
  color: #fff;
}
.input-group .search:focus {
  height: calc(1.5em + 0.5rem + 2px);
  width: 200px;
  border-radius: 3px;
  color: #26547c;
  cursor: initial;
}
.input-group .search:focus::-webkit-input-placeholder {
  color: #a1a1a1;
}
.input-group .search:focus::-moz-placeholder {
  color: #a1a1a1;
}
.input-group .search:focus:-ms-input-placeholder {
  color: #a1a1a1;
}
.input-group .search:focus::-ms-input-placeholder {
  color: #a1a1a1;
}
.input-group .search:focus::placeholder {
  color: #a1a1a1;
}
.input-group .search:focus ~ .bar {
  box-shadow: none;
  opacity: 0;
  right: 0;
  top: 5px;
}
.input-group .search {
  background: #fff
    url(data:image/gif;base64,R0lGODlhBwAHAIAAAP///5KSkiH5BAAAAAAALAAAAAAHAAcAAAIMTICmsGrIXnLxuDMLADs=)
    no-repeat right -10px center;
  /*border: 1px solid #999;
  padding: 3px 18px 3px 4px; /* Use the same right padding (18) in jQ! */
  /*border-radius: 3px;
  transition: background 0.4s;*/
}
.input-group .search.x {
  background-position: right 10px center;
}
.input-group .search.onX {
  cursor: pointer;
}
.input-group .search::-ms-clear {
  display: none;
  width: 0;
  height: 0;
}
/* End search input */
</style>